<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    >
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Dashboard</p>
      </sidebar-link>

      <div @click="toggleDropdown('listings')" class="parent-link">
        <md-icon>list</md-icon>
        <p class="link_text">Listings</p>
        <md-icon class="dropdown-icon">
          {{ dropdowns.listings ? 'expand_less' : 'expand_more' }}
        </md-icon>
      </div>
      <div v-if="dropdowns.listings" class="sub-links">
        <sidebar-link to="/create_listing">
          <md-icon>list</md-icon>
          <p>Create Listing</p>
        </sidebar-link>
        <sidebar-link to="/listings">
          <md-icon>list</md-icon>
          <p>Listings</p>
        </sidebar-link>
        <sidebar-link to="/drafts">
          <md-icon>list</md-icon>
          <p>Drafts</p>
        </sidebar-link>

<!--        <sidebar-link to="/availability">-->
<!--          <md-icon>calendar_today</md-icon>-->
<!--          <p>Availability</p>-->
<!--        </sidebar-link>-->
<!--        <sidebar-link to="/payment">-->
<!--          <md-icon>attach_money</md-icon>-->
<!--          <p>Payment</p>-->
<!--        </sidebar-link>-->
      </div>

      <div @click="toggleDropdown('payment')" class="parent-link">
        <md-icon>attach_money</md-icon>
        <p class="link_text">Payment</p>
        <md-icon class="dropdown-icon">
          {{ dropdowns.payment ? 'expand_less' : 'expand_more' }}
        </md-icon>
      </div>
      <div v-if="dropdowns.payment" class="sub-links">
        <sidebar-link to="/integrations">
          <md-icon>attach_money</md-icon>
          <p>Integrations</p>
        </sidebar-link>
        <sidebar-link to="/payment">
          <md-icon>list</md-icon>
          <p>Payment methods</p>
        </sidebar-link>
        <!--        <sidebar-link to="/availability">-->
        <!--          <md-icon>calendar_today</md-icon>-->
        <!--          <p>Availability</p>-->
        <!--        </sidebar-link>-->
<!--        <sidebar-link to="/payment">-->
<!--          <md-icon>attach_money</md-icon>-->
<!--          <p>Payment</p>-->
<!--        </sidebar-link>-->
      </div>

      <div @click="toggleDropdown('reservations')" class="parent-link">
        <md-icon>event_available</md-icon>
        <p class="link_text">Reservations</p>
        <md-icon class="dropdown-icon">
          {{ dropdowns.reservations ? 'expand_less' : 'expand_more' }}
        </md-icon>
      </div>
      <div v-if="dropdowns.reservations" class="sub-links">
        <sidebar-link to="/reservations">
          <md-icon>event_available</md-icon>
          <p>Reservations</p>
        </sidebar-link>
<!--        <sidebar-link to="/payment">-->
<!--          <md-icon>list</md-icon>-->
<!--          <p>Payment methods</p>-->
<!--        </sidebar-link>-->
      </div>
<!--      <sidebar-link to="/listings">-->
<!--        <md-icon>looks</md-icon>-->
<!--        <p>Channel manager</p>-->
<!--      </sidebar-link>-->
<!--      <sidebar-link to="/user">-->
<!--        <md-icon>person</md-icon>-->
<!--        <p>User Profile</p>-->
<!--      </sidebar-link>-->
<!--      <sidebar-link to="/table">-->
<!--        <md-icon>content_paste</md-icon>-->
<!--        <p>Table list</p>-->
<!--      </sidebar-link>-->
<!--      <sidebar-link to="/typography">-->
<!--        <md-icon>library_books</md-icon>-->
<!--        <p>Typography</p>-->
<!--      </sidebar-link>-->
<!--      <sidebar-link to="/icons">-->
<!--        <md-icon>bubble_chart</md-icon>-->
<!--        <p>Icons</p>-->
<!--      </sidebar-link>-->
<!--      <sidebar-link to="/maps">-->
<!--        <md-icon>location_on</md-icon>-->
<!--        <p>Maps</p>-->
<!--      </sidebar-link>-->
<!--      <sidebar-link to="/notifications">-->
<!--        <md-icon>notifications</md-icon>-->
<!--        <p>Notifications</p>-->
<!--      </sidebar-link>-->
<!--      <sidebar-link to="/upgrade" class="active-pro">-->
<!--        <md-icon>unarchive</md-icon>-->
<!--        <p>Upgrade to PRO</p>-->
<!--      </sidebar-link>-->
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <fixed-plugin
        :color.sync="sidebarBackground"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin>
      <dashboard-content> </dashboard-content>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
import FixedPlugin from "./Extra/FixedPlugin.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu,
    FixedPlugin,
  },
  data() {
    return {
      sidebarBackground: "green",
      sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg"),
      dropdowns: {
        listings: false,
        payment: false,
        reservations: false
      },
    };
  },
  methods: {
    toggleDropdown(menu) {
      this.dropdowns[menu] = !this.dropdowns[menu];
    },
  },
};
</script>
<style scoped lang="scss">
.parent-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 8px 20px 2px;
  padding: 10px 15px;
  & .link_text {
    color: #fff;
    line-height: 30px;
    font-size: 14px;
    font-weight: 300;
  }
  ::v-deep i {
    margin-right: 5px !important;
  }
  &:hover {
    background-color: rgba(200, 200, 200, 0.2);
  }
}
.sub-links {
  padding-left: 24px;
}
.dropdown-icon {
  font-size: 20px;
}
</style>
